import { render, staticRenderFns } from "./AppSelect.vue?vue&type=template&id=dc411428&scoped=true"
import script from "./AppSelect.vue?vue&type=script&lang=js"
export * from "./AppSelect.vue?vue&type=script&lang=js"
import style0 from "./AppSelect.vue?vue&type=style&index=0&id=dc411428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc411428",
  null
  
)

export default component.exports